import { Badge, Group } from '@mantine/core';
import { Tag } from '../../types/tag.type';

// Shared team filter — an empty selection means "all teams". Used by both
// the calendar and the season leaderboards, so picking a team scopes both.
export function TeamFilterBadges({ allTeams, selectedTeams, onToggle }: {
  allTeams: string[];
  selectedTeams: string[];
  onToggle: (team: string) => void;
}) {
  if (allTeams.length <= 1) return null;
  return (
    <Group gap="xs">
      {allTeams.map((team) => {
        const active = selectedTeams.length === 0 || selectedTeams.includes(team);
        return (
          <Badge
            key={team}
            variant={active ? 'filled' : 'outline'}
            color="indigo"
            size="sm"
            style={{ cursor: 'pointer' }}
            onClick={() => onToggle(team)}
          >
            {team}
          </Badge>
        );
      })}
    </Group>
  );
}

// Training tag filter — an empty selection means "all tags". Mirrors
// TeamFilterBadges but for the training side of the calendar.
export function TrainingTagBadges({ allTags, selectedTagIds, onToggle }: {
  allTags: Tag[];
  selectedTagIds: string[];
  onToggle: (tagId: string) => void;
}) {
  if (allTags.length === 0) return null;
  return (
    <Group gap="xs">
      {allTags.map((tag) => {
        const id = tag.id.toString();
        const active = selectedTagIds.length === 0 || selectedTagIds.includes(id);
        return (
          <Badge
            key={tag.id}
            variant={active ? 'filled' : 'outline'}
            color={tag.color || 'teal'}
            size="sm"
            style={{ cursor: 'pointer' }}
            onClick={() => onToggle(id)}
          >
            {tag.name}
          </Badge>
        );
      })}
    </Group>
  );
}
